'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
const wipResourceTypes = [ResourceType.ResourceTypeUnspecified, ResourceType.AwsEfs, ResourceType.AwsFsx, ResourceType.AwsKeyspacesTable, ResourceType.AwsNeptune, ResourceType.AzureFileShare, ResourceType.AzureDisk, ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm, ResourceType.AzureSqlDatabase, ResourceType.AzureSqlManagedInstance, ResourceType.AzureMysql, ResourceType.AzurePostgresql, ResourceType.AzureCosmosdbMongodb, ResourceType.AzureCosmosdbNosql, ResourceType.AzureAksNamespace, ResourceType.GcpGkeNamespace, ResourceType.GcpCloudFirestore, ResourceType.GoogleWorkspaceResource];
export const useSupportedResourceTypes = t0 => {
  const $ = _c(20);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    AzureSqlDatabaseSupport,
    SapHanaPitrSupport,
    AwsKeyspacesSupport,
    AzureFilesSupport
  } = useFeatureFlags();
  let t2;
  if ($[2] !== AwsKeyspacesSupport) {
    t2 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[2] = AwsKeyspacesSupport;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== AzureSqlDatabaseSupport) {
    t3 = AzureSqlDatabaseSupport ? [ResourceType.AzureSqlDatabase] : [];
    $[4] = AzureSqlDatabaseSupport;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== SapHanaPitrSupport) {
    t4 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[6] = SapHanaPitrSupport;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== AzureFilesSupport) {
    t5 = AzureFilesSupport ? [ResourceType.AzureFileShare] : [];
    $[8] = AzureFilesSupport;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ...t2, ...t3, ...t4, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t5];
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const ffResources = t6;
  let t7;
  if ($[15] !== cloudProviders || $[16] !== ffResources || $[17] !== isDemo || $[18] !== isDev) {
    t7 = Object.values(ResourceType).filter(x => x !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[x]?.provider) : true) && (isDemo || isDev || !wipResourceTypes.includes(x) || ffResources.includes(x)));
    $[15] = cloudProviders;
    $[16] = ffResources;
    $[17] = isDemo;
    $[18] = isDev;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};